import React from 'react';
import '../../scss/reusables/descriptor.scss';
import  { CKEditor } from 'ckeditor4-react';

export default function Descriptor(props) {
    const { defaultdescription, setDescription, readOnly, resize } = props;
    return (
        <div className={`App ${readOnly && 'hide-toolbar'}`} id='description'>
            <style>{`
                .cke_top {
                    display: 'block';
                }
                .hide-toolbar .cke_top {
                    display: ${readOnly ? 'none !important' : 'block'};
                }
            `}</style>
            <CKEditor
            key={'description'}
            id={'description'}
            name={'description'}
                initData={defaultdescription ? defaultdescription : ''}
                config={readOnly && {
                    readOnly: true,            // disables editing
                    removePlugins: "elementspath", // removes the bottom status path
                    resize_enabled: resize, 
                  }}
                onFocus={ ( { editor } ) => {
                    editor.on( 'change', () => {
                        console.log( 'The Document has changed!');
                        var str = editor.getData()
                        // var data = str.substring(str.indexOf('>')+1, str.lastIndexOf('<'));
                        setDescription(str);
                    } );
                } }
            />
        </div>
    );
}